module.exports = __webpack_public_path__ + "static/img/download_android.a8464dda.png";